import { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

type ApiProviderProps = {
  children: ReactNode
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
})

export function ApiProvider(props: ApiProviderProps) {
  const { children } = props

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
